export default "__VITE_ASSET__BJlrmHmB__"